import type { LoadingOverlayProps as MantineLoadingOverlayProps } from '@mantine/core';
import { LoadingOverlay as MantineLoadingOverlay } from '@mantine/core';

import type { LockedProps } from '../types';

export type LoadingOverlayProps = Omit<MantineLoadingOverlayProps, LockedProps>;

/**
 * ### LoadingOverlay
 *
 * @description
 * Mantine's LoadingOverlay minus per-call-site style overrides (see {@link LockedProps}). Covers
 * its nearest positioned ancestor with a spinner while `visible` — use it to keep already-rendered
 * content in place during a refetch, rather than swapping the whole region for a `Loader`.
 *
 * Its sibling {@link DisabledOverlay} is the read-only counterpart: same cover, no spinner.
 *
 * @example
 * ```tsx
 * <Card pos="relative">
 *   <LoadingOverlay visible={isLoading} />
 *   {summary}
 * </Card>
 * ```
 */
export const LoadingOverlay = (props: LoadingOverlayProps) => {
  return <MantineLoadingOverlay {...props} />;
};
